"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.preview.title': '机器人测试预览',
    'botTest.preview.run': '运行测试',
    'botTest.preview.edit': '编辑测试',
    'botTest.preview.back': '返回列表',
    'botTest.preview.section.basic_info': '基本信息',
    'botTest.preview.section.statistics': '统计信息',
    'botTest.preview.section.testers': '测试配置',
    'botTest.preview.not_provided': '未提供',
    'botTest.preview.total_testers': '测试者总数',
    'botTest.preview.total_targets': '目标总数',
    'botTest.preview.creator': '创建者',
    'botTest.preview.unknown_creator': '未知',
    'botTest.preview.testers_count': '测试者',
    'botTest.preview.targets_count': '目标',
    'botTest.preview.created_date': '创建日期',
    'botTest.preview.updated_date': '最后更新',
    'botTest.preview.tester_configuration': '测试者配置',
    'botTest.preview.prompt_overridden': '提示词已覆盖',
    'botTest.preview.no_targets': '未配置目标',
    'botTest.preview.unknown_avatar': '未知头像',
    'botTest.preview.no_testers': '未配置测试者',
    'botTest.preview.no_testers_description': '添加测试者以配置AI模型和用于测试的提示词。',
    'botTest.preview.not_found': '未找到机器人测试',
    'botTest.preview.not_found_description': '无法找到请求的机器人测试或已被删除。',
    'botTest.preview.no_model': '无模型',
    'botTest.preview.unknown_model': '未知模型',
    'botTest.preview.status.unknown': '未知',
    'botTest.preview.status.active': '活跃',
    'botTest.preview.status.inactive': '不活跃',
    'botTest.preview.status.standby': '待机',
    'botTest.preview.status.pending': '等待中',
    'botTest.preview.status.running': '运行中',
    'botTest.preview.status.completed': '已完成',
    'botTest.preview.status.failed': '失败',
    'botTest.preview.error.load_failed': '加载机器人测试失败',
    'botTest.preview.run_confirmation': '您确定要运行此测试吗？',
    'botTest.preview.run_started': '机器人测试启动成功',
    'botTest.preview.run_failed': '启动机器人测试失败',
    'botTest.preview.tabs.data': '数据',
    'botTest.preview.tabs.test_results': '测试结果',
    'botTest.preview.section.test_results': '测试结果',
    'botTest.preview.no_test_results': '没有可用的测试结果',
    'botTest.preview.no_test_results_description': '运行机器人测试以在此处查看结果。',
    'botTest.preview.model': '模型',
    'botTest.preview.temperature': '温度',
    'botTest.preview.completed': '已完成',
    'botTest.preview.failed': '失败',
    'botTest.preview.status': '状态',
    'botTest.preview.messages': '消息',
    'botTest.preview.tokens': '令牌',
    'botTest.preview.duration': '持续时间',
    'botTest.preview.total_messages': '总消息数',
    'botTest.preview.total_tokens': '总令牌数',
    'botTest.preview.avg_duration': '平均持续时间',
};
